import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ContactDialogComponent } from '../contact-dialog/contact-dialog.component';

@Component({
  selector: 'app-contact-bubble',
  templateUrl: './contact-bubble.component.html',
  styleUrls: ['./contact-bubble.component.scss']
})
export class ContactBubbleComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  ngOnInit() { }

  public openHelpDialog() {
    this.dialog.open(ContactDialogComponent);
  }

}
